import { FormattedMessage } from "react-intl";

import { Text } from "@/components/atoms/Text";

type FsvMenuCardDescriptionProps = {
  isDepositListing: boolean;
  minimumSpendCategoryPhrase: string;
  minSpendFormatted: string;
  onLinkClick: () => void;
};

/**
 * Description slot for FsvMenuCard — renders the minimum spend label as a
 * link to the "how credit works" section. The href works on its own (the
 * hash opens the accordion); onLinkClick adds the smooth scroll.
 */
export const FsvMenuCardDescription = ({
  isDepositListing,
  minimumSpendCategoryPhrase,
  minSpendFormatted,
  onLinkClick,
}: FsvMenuCardDescriptionProps) => (
  <div>
    <Text
      element="a"
      href="#how-credit-works"
      typeface="body-2-m"
      className="tw-relative md:tw-body-1-m tw-underline tw-text-gray-600"
      data-testid="fsv-menu-card-minimum-spend-link"
      onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        onLinkClick();
      }}
    >
      {isDepositListing && minimumSpendCategoryPhrase ? (
        <FormattedMessage
          defaultMessage="{minSpend} {category} minimum"
          values={{
            minSpend: minSpendFormatted,
            category: minimumSpendCategoryPhrase,
          }}
        />
      ) : (
        <FormattedMessage
          defaultMessage="{minSpend} minimum spend at venue"
          values={{ minSpend: minSpendFormatted }}
        />
      )}
    </Text>
  </div>
);
